import { orchestrator } from 'satcheljs';
import onAcquisitionsRemoteRefresh from 'owa-m365-acquisitions/lib/actions/onAcquisitionsRemoteRefresh';
import { updateAppBarTiles } from '../utils/updateAppBarTiles';
import { writeAcquisitionQueries } from '../utils/writeAcquisitionQueries';
import { getApplicationSettings } from 'owa-application-settings';
import { trace } from 'owa-trace';
import getExtensibilityState from 'owa-addins-store/lib/store/getExtensibilityState';
import isExtensibilityContextInitialized from 'owa-addins-store/lib/store/isExtensibilityContextInitialized';
import { ExtensibilityModeEnum } from 'owa-addins-types';

/**
 * Runs when MOS3 app service data refreshes. Implies MOS3 is enabled and available.
 */
orchestrator(onAcquisitionsRemoteRefresh, async ({ mailboxInfo }) => {
    // Debug logging for RCA of add-ins disappearing mid-session
    if (getApplicationSettings('Addin')?.isVerboseLogsEnabled) {
        const extState = getExtensibilityState(mailboxInfo);
        const isExtCtxInit = isExtensibilityContextInitialized(mailboxInfo);
        trace.info(
            `[flyout-debug] onAcquisitionsRemoteRefresh triggered - ` +
                `isExtCtxInit: ${isExtCtxInit}, ` +
                `enabledAddinCommandsInit: ${extState?.EnabledAddinCommands?.isInitialized}, ` +
                `composeAddins: ${
                    extState?.EnabledAddinCommands?.getExtensionPoint?.(
                        ExtensibilityModeEnum.MessageCompose
                    )?.length ?? 0
                }, ` +
                `readAddins: ${
                    extState?.EnabledAddinCommands?.getExtensionPoint?.(
                        ExtensibilityModeEnum.MessageRead
                    )?.length ?? 0
                }, ` +
                `timestamp: ${Date.now()}`,
            'addins'
        );
    }

    // redraw the app bar with the current cached data
    await writeAcquisitionQueries(mailboxInfo);

    // update the AppBarTiles setting which saves stub tiles to improve app bar flicker on boot
    await updateAppBarTiles(mailboxInfo);
});
